module.exports = __webpack_public_path__ + "assets/img/dzh-13.76b7fb5d.jpg";